import React, { useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Sheet, SheetContent } from './ui/sheet';
import DynamicFormRenderer from '../components/DynamicFormRenderer';
import NavigationBar from '../components/NavigationBar';
import Snackbar from '../components/Snackbar';

const EntityProfileForm = () => {
    const { entityId, companyEntityId, eventNameId: routeEventNameId } = useParams();
    const navigate = useNavigate();
    // The event is part of the route (/event/:eventNameId/entity-profile/...). The browser-wide
    // last_event value is only a fallback for the legacy /entity-profile/... links.
    const eventNameId = routeEventNameId || localStorage.getItem('last_event') || 'F4C2025';
    const [isOpen, setIsOpen] = useState(true);
    const [snackbar, setSnackbar] = useState({ isOpen: false, message: '', type: 'success' });

    const handleSave = useCallback(() => {
        // Show success message with snackbar
        setSnackbar({ isOpen: true, message: 'Your Profile Has Been Saved!', type: 'success' });
        // Redirect to home after 2 seconds
        setTimeout(() => {
            navigate(`/event/${eventNameId}/home`);
        }, 1000);
    }, [navigate, eventNameId]);

    const handleError = useCallback((errorMessage) => {
        // Show error snackbar (for access errors)
        setSnackbar({ isOpen: true, message: errorMessage, type: 'error' });
        // Redirect to home after showing error
        setTimeout(() => {
            navigate(`/event/${eventNameId}/home`);
        }, 3000);
    }, [navigate, eventNameId]);

    const handleValidationError = useCallback((errorMessage) => {
        // Show error snackbar without redirecting (for validation errors)
        setSnackbar({ isOpen: true, message: errorMessage, type: 'error' });
    }, []);

    const handleCancel = () => {
        setIsOpen(false);
        navigate(`/event/${eventNameId}/home`);
    };

    return (
        <>
            <NavigationBar />
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
                <SheetContent className="w-full sm:max-w-6xl overflow-y-auto">
                    <DynamicFormRenderer
                        entityId={parseInt(entityId)}
                        companyEntityId={parseInt(companyEntityId)}
                        eventNameId={eventNameId}
                        onSave={handleSave}
                        onCancel={handleCancel}
                        onError={handleError}
                        onValidationError={handleValidationError}
                    />
                </SheetContent>
            </Sheet>

            {/* Snackbar Notification */}
            <Snackbar
                message={snackbar.message}
                type={snackbar.type}
                isOpen={snackbar.isOpen}
                onClose={() => setSnackbar({ ...snackbar, isOpen: false })}
                duration={3000}
            />
        </>
    );
};

export default EntityProfileForm;
